import { BroadcastChannel, createLeaderElection } from 'broadcast-channel'
import { primaryEventBus, PrimaryEvents } from 'v2/utils/event-bus/primary'
import { tabLogger } from 'v2/utils/logger'

class PrimaryTabManager {
  private static instance: PrimaryTabManager

  public channel: BroadcastChannel

  private elector: ReturnType<typeof createLeaderElection>

  private constructor() {
    this.channel = new BroadcastChannel('primary-tab-election')
    this.elector = createLeaderElection(this.channel)
    tabLogger.log('Primary tab manager - constructor called')

    // Update subscribers when leadership changes
    this.elector.hasLeader().then((hasLeader) => {
      primaryEventBus.emit(PrimaryEvents.PRIMARY_TAB_STATUS, hasLeader && this.elector.isLeader)
    })

    this.elector.onduplicate = () => {
      // If we detect a duplicate primary tab, reload the page
      tabLogger.warn('Duplicate primary tab detected')
      window.location.reload()
    }
  }

  public static getInstance(): PrimaryTabManager {
    if (!PrimaryTabManager.instance) {
      PrimaryTabManager.instance = new PrimaryTabManager()
    }
    return PrimaryTabManager.instance
  }

  public init(): void {
    tabLogger.log('Primary tab manager - init called')
    if (!this.elector.isLeader)
      this.elector.awaitLeadership().then(() => {
        tabLogger.log('This tab is now the primary tab')
        window.cx.isPrimary = this.elector.isLeader
        primaryEventBus.emit(PrimaryEvents.PRIMARY_TAB_STATUS, true)
      })
  }

  public getIsPrimary(): boolean {
    window.cx.isPrimary = this.elector.isLeader
    return this.elector.isLeader
  }
}

export const primaryTabManager = PrimaryTabManager.getInstance()
